import axios from "axios";

var axiosInstance;
// eslint-disable-next-line
axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_SERVICE_API,
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  }
});

axiosInstance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.headers["content-type"]) {
      if (
        response.headers["content-type"].includes(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) ||
        response.headers["content-type"].includes("text/csv; charset=UTF-8")
      ) {
        return { data: response.data, headers: response.headers };
      }
    }

    return response.data;
  },
  function (error) {
    // Do something with response error
    if (error.response.status == "401") {
      // localStorage.clear();
      // window.location.href = "/logout";
    }
    if (!error.response) {
      return Promise.reject(
        "เกิดข้อผิดพลาด ไม่สามารถเชื่อมต่อเซิฟเวอร์ได้ กรุณาลองใหม่ภายหลัง!"
      );
    }
    return Promise.reject(error.response.data);
  }
);

export default axiosInstance;
